import React from 'react';
import { FieldError, FieldErrorsImpl, Merge } from 'react-hook-form';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleExclamation } from '@fortawesome/free-solid-svg-icons';

interface Props {
  error?: { message: string } | FieldError | Merge<FieldError, FieldErrorsImpl<any>> | undefined;
  clarification?: string;
  maxLength?: number;
  currentLength?: number;
}

const ErrorBlock: React.FC<Props> = ({ error, clarification, maxLength, currentLength }) => {
  return (
    <div className="form-error-block">
      {/* LEFT SPACER — balances the counter on the right */}
      <div className="form-error-spacer" />

      {/* CENTER — error or clarification */}
      <div className="form-error-center">
        {error ? (
          <>
            <FontAwesomeIcon icon={faCircleExclamation} className="me-2" />
            {error.message}
          </>
        ) : (
          <span className="form-clarification">{clarification}&nbsp;</span>
        )}
      </div>

      {/* RIGHT — max length counter */}
      <div className="form-error-right">
        {maxLength !== undefined && (
          <span>
            {currentLength}/{maxLength}
          </span>
        )}
      </div>
    </div>
  );
};

export default ErrorBlock;
